import React from "react";

const MountainSvg = props => (
  <svg width="411px" height="298px" viewBox="0 0 411 298" {...props}>
    <defs>
      <path
        d="M14.836 235.682l115.71-121.615a9.23 9.23 0 0113.21-.17l43.81 43.744L274.5 71.219a9.23 9.23 0 0113.692.751l132.53 164.279a9.23 9.23 0 01-7.184 15.026H21.524a9.23 9.23 0 01-6.688-15.593z"
        id="a"
      />
    </defs>
    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <path
        d="M170.5 111c-30.652 0-55.5-24.848-55.5-55.5S139.848 0 170.5 0 226 24.848 226 55.5 201.152 111 170.5 111zm0-13.875c22.989 0 41.625-18.636 41.625-41.625S193.489 13.875 170.5 13.875 128.875 32.511 128.875 55.5s18.636 41.625 41.625 41.625z"
        fill="#FF6363"
        className="mountain-svg--sun"
        transform="translate(-106 -171) translate(106 171)"
      />
      <g transform="translate(-106 -171) translate(94 171) translate(0 46)">
        <mask fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <use fill="#FF6363" xlinkHref="#a" />
        <path
          d="M229.466 136.98L282 86.339l41.348 51.457a.923.923 0 01-.27 1.385c-3.372 1.88-8.828 2.82-16.367 2.82-12.652 0-28.795-13.317-41.24-13.317-7.042 0-18.716 3.273-35.02 9.819a.923.923 0 01-.985-1.521zM103.01 162.372L137.388 129l14.916 15.263a5.75 5.75 0 01-4.112 9.768c-7.996 0-21.11 12.969-28.976 12.969-11.084 0-16.486-1.543-16.206-4.628z"
          fill="#FFF"
        />
        <path
          d="M298.698 6.971l-.847-4.716L310.875 0l.847 4.716 4.982-.863L319 16.644 282.296 23 280 10.21l18.698-3.239z"
          fill="#FF6363"
        />
        <path fill="#FF6363" transform="rotate(-80 75.5 23)" d="M70 14H81V32H70z" />
        <path fill="#FF6363" d="M75 100H86V111H75z" />
      </g>
    </g>
  </svg>
);

export default MountainSvg;
